import { Component, ContentChild, TemplateRef, Input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-tooltip-wrapper',
  standalone: true,
  imports: [NgTemplateOutlet],
  template: `
    <div class="tooltip-wrapper">
      <div class="tooltip-content" (mouseenter)="showTooltip = true" (mouseleave)="showTooltip = false">
        <ng-content></ng-content>
      </div>
      @if (tooltipTemplate && showTooltip) {
        <div class="tooltip-box"
             [class.row-style]="rowStyle"
             [class.tooltip-box-right]="right"
             [class.no-padding]="noPadding"
             [class.tooltip-box-full-width]="fullWidth"
             [class.tooltip-box-content-width]="contentWidth"
             [class.border-top]="border === 'top'"
             [class.border-around]="border === 'around'"
             [class.border-none]="border === 'none'">
          <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
      }
    </div>
  `,
  styleUrl: './tooltip-wrapper.component.scss'
})
export class TooltipWrapperComponent {
  @ContentChild('tooltip') tooltipTemplate?: TemplateRef<any>;
  @Input() right = false;
  @Input() fullWidth = false;
  @Input() contentWidth = false;
  @Input() noPadding = false;
  @Input() border: 'top' | 'around' | 'none' = 'top';
  @Input() rowStyle = false;

  showTooltip = localStorage.getItem('show-all-tooltips') === 'true';
}
